import { CircularProgress } from '@material-ui/core';
import { useLoadingModalOpened } from 'services/ui/uiSlice';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  min-width: 100vw;
  min-height: 100vh;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
`;

type Props = {
  isOpen: boolean;
};

export const LoadingDialog = () => {
  const isOpen = useLoadingModalOpened();
  if (!isOpen) return null;
  return (
    <Wrapper>
      <CircularProgress />
    </Wrapper>
  );
};
